<template>
<div class="Pin">
    <svg version="1.1" id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 710 710" enable-background="new 0 0 710 710" xml:space="preserve">
        <g>
            <path fill="none" d="M610.3,355C469.3,355,355,240.7,355,99.7C355,240.7,240.7,355,99.7,355c141,0,255.3,114.3,255.3,255.3

C355,469.3,469.3,355,610.3,355z" />
            <path fill="#12202F" d="M610.3,355C610.3,214,496,99.7,355,99.7C355,240.7,469.3,355,610.3,355z" />
            <path fill="#12202F" d="M355,610.3c141,0,255.3-114.3,255.3-255.3C469.3,355,355,469.3,355,610.3z" />
            <path fill="#12202F" d="M355,99.7C214,99.7,99.7,214,99.7,355C240.7,355,355,240.7,355,99.7z" />
            <path fill="#12202F" d="M99.7,355C99.7,496,214,610.3,355,610.3C355,469.3,240.7,355,99.7,355z" />
        </g>
    </svg>
</div>
</template>

<script>
export default {
    name: "Pin"
};
</script>

<style scoped>
</style>
